module.exports = __webpack_public_path__ + "static/media/corporateStep7.20ad49a3.svg";